import React, { useState } from 'react';
import { arrayOf, bool, func, oneOfType, shape, string, object } from 'prop-types';
import _ from 'lodash';
import HotLinks from '../../molecules/HotLinks';
import List from '../../molecules/List';
import { Box, Button, HorizontalRule, Image, Text, Accordion, Link } from '../../atoms';
import { Container, Content, LogoutLink, IconsContainer, SalesChannels, SaleChannel, LinkContainer } from './sidebar-menu.styles';
import SidebarHeading from './sidebar-heading';

const SidebarMenu = props => {
  var _categoryList$list, _categoryList$list2, _externalLinks$list, _externalLinks$list2, _services$list, _services$list2, _social$links;

  const {
    account,
    actionButtons,
    categoryList,
    externalLinks,
    header,
    helperText,
    salesChannels,
    moreInformation,
    services,
    showcaseLinks,
    groupedLinks,
    social
  } = (props == null ? void 0 : props.data) || {};
  const {
    onCollapsedClick,
    onMenuHeaderClick,
    onMenuItemClick,
    onLogout
  } = props;

  const getLabels = () => {
    if (Array.isArray(helperText)) {
      const [label, ...otherLabels] = helperText;
      return [label, otherLabels];
    }

    return [helperText || '', []];
  };

  const [label, otherLabels] = getLabels();
  const [collapsed, setCollapsed] = useState(true);

  const handleCollapsed = () => {
    onCollapsedClick();
    setCollapsed(!collapsed);
  };

  const [openIndices, setOpenIndices] = useState([]);

  const handleAccordionClick = index => {
    if (openIndices.includes(index)) {
      setOpenIndices(openIndices.filter(i => i !== index));
    } else {
      setOpenIndices([...openIndices, index]);
    }
  };

  return /*#__PURE__*/React.createElement(Container, null, header && /*#__PURE__*/React.createElement(SidebarHeading, {
    data: header,
    onMenuHeaderClick: onMenuHeaderClick
  }), /*#__PURE__*/React.createElement(Content, null, !!(showcaseLinks != null && showcaseLinks.length) && /*#__PURE__*/React.createElement(HotLinks, {
    directionType: "column",
    items: showcaseLinks
  }), (groupedLinks == null ? void 0 : groupedLinks.map((group, i) => /*#__PURE__*/React.createElement(Box, {
    bg: "white",
    borderRadius: 4,
    marginBottom: 10,
    marginTop: 10,
    key: i
  }, /*#__PURE__*/React.createElement(List, {
    divided: true
  }, group.map((item, index) => /*#__PURE__*/React.createElement(List.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    onClick: e => onMenuItemClick(e, item),
    startIcon: item.startIcon,
    fill: "background.primary",
    "data-testid": "menu-item"
  }, item == null ? void 0 : item.label)))))) || null, (categoryList == null ? void 0 : (_categoryList$list = categoryList.list) == null ? void 0 : _categoryList$list.length) && /*#__PURE__*/React.createElement(Box, {
    bg: "white"
  }, /*#__PURE__*/React.createElement(List.Collapse, {
    trigger: collapsed,
    bg: "white",
    fill: "background.primary",
    collapsedIn: categoryList == null ? void 0 : categoryList.show,
    renderAction: collapsed && /*#__PURE__*/React.createElement(List.Action, {
      endIcon: "ChevronDown",
      fontWeight: "medium",
      onClick: handleCollapsed
    }, categoryList == null ? void 0 : categoryList.collapseText),
    divided: true,
    "data-testid": "category-list"
  }, categoryList == null ? void 0 : (_categoryList$list2 = categoryList.list) == null ? void 0 : _categoryList$list2.map((item, index) => {
    var _item$subcategoriesLi;

    return /*#__PURE__*/React.createElement(Box, {
      key: index,
      bg: "white",
      borderRadius: 4
    }, (item == null ? void 0 : item.subcategoriesList) && /*#__PURE__*/React.createElement(Accordion, {
      id: item == null ? void 0 : item.id,
      title: item.label,
      closeIcon: "ChevronUp",
      open: openIndices.includes(index),
      onClick: () => handleAccordionClick(index),
      fontWeight: "regular",
      openIcon: "ChevronDown",
      mb: "1px"
    }, /*#__PURE__*/React.createElement(Box, {
      bg: "#F4F4F4",
      borderRadius: 4,
      height: "350px",
      overflow: "scroll"
    }, item == null ? void 0 : (_item$subcategoriesLi = item.subcategoriesList) == null ? void 0 : _item$subcategoriesLi.map((subItem, value) => /*#__PURE__*/React.createElement(LinkContainer, {
      key: value
    }, /*#__PURE__*/React.createElement(Link, {
      as: "a",
      href: subItem == null ? void 0 : subItem.url,
      rel: subItem == null ? void 0 : subItem.rel,
      color: subItem.highlight ? 'rgb(164, 0, 225)' : null,
      onClick: e => onMenuItemClick(e, subItem, 'subcategoria:')
    }, subItem == null ? void 0 : subItem.label))))), !(item != null && item.subcategoriesList) && /*#__PURE__*/React.createElement(List, {
      divided: true
    }, /*#__PURE__*/React.createElement(List.Item, {
      key: index,
      as: "a",
      href: (item == null ? void 0 : item.path) || (item == null ? void 0 : item.url),
      rel: item == null ? void 0 : item.rel,
      onClick: e => onMenuItemClick(e, item),
      startIcon: item != null && item.id ? `Category${item == null ? void 0 : item.id}` : undefined,
      fill: "background.primary",
      "data-testid": "menu-item",
      mb: "1px"
    }, item == null ? void 0 : item.label)));
  }))), (externalLinks == null ? void 0 : (_externalLinks$list = externalLinks.list) == null ? void 0 : _externalLinks$list.length) && /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "medium",
    px: 3,
    py: 3
  }, externalLinks == null ? void 0 : externalLinks.title), /*#__PURE__*/React.createElement(List, {
    bg: "white",
    borderRadius: 4,
    divided: true
  }, externalLinks == null ? void 0 : (_externalLinks$list2 = externalLinks.list) == null ? void 0 : _externalLinks$list2.map((item, index) => /*#__PURE__*/React.createElement(List.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: (item == null ? void 0 : item.id) && `Logo${item == null ? void 0 : item.id}`,
    endIcon: item == null ? void 0 : item.endIcon,
    fontWeight: item == null ? void 0 : item.fontWeight,
    onClick: e => onMenuItemClick(e, item, 'nossas-marcas:')
  }, item == null ? void 0 : item.label)))), (services == null ? void 0 : (_services$list = services.list) == null ? void 0 : _services$list.length) && /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: "medium",
    px: 3,
    py: 3
  }, services == null ? void 0 : services.title), /*#__PURE__*/React.createElement(List, {
    bg: "white",
    borderRadius: 4,
    divided: true
  }, services == null ? void 0 : (_services$list2 = services.list) == null ? void 0 : _services$list2.map((item, index) => /*#__PURE__*/React.createElement(List.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: `Service${item == null ? void 0 : item.id}`,
    fill: "gray",
    onClick: e => onMenuItemClick(e, item, 'servicos:')
  }, item == null ? void 0 : item.label)))), (moreInformation == null ? void 0 : moreInformation.length) && /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(List, {
    bg: "white",
    borderRadius: 4,
    divided: true
  }, moreInformation == null ? void 0 : moreInformation.map((item, index) => /*#__PURE__*/React.createElement(List.Item, {
    key: index,
    as: "a",
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    startIcon: item == null ? void 0 : item.id,
    fill: "gray",
    onClick: e => onMenuItemClick(e, item)
  }, item == null ? void 0 : item.label)))), (actionButtons == null ? void 0 : actionButtons.length) && /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, actionButtons == null ? void 0 : actionButtons.map((item, index) => /*#__PURE__*/React.createElement(Button, {
    key: index,
    href: item == null ? void 0 : item.url,
    rel: item == null ? void 0 : item.rel,
    as: "a",
    color: "primary",
    startIcon: item == null ? void 0 : item.id,
    uppercase: false,
    mb: 2,
    centered: true,
    full: true,
    onClick: e => onMenuItemClick(e, item, 'contato:')
  }, item == null ? void 0 : item.label)))), label && /*#__PURE__*/React.createElement(Box, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 1,
    textAlign: "center",
    color: "darkGray"
  }, label), /*#__PURE__*/React.createElement(SalesChannels, {
    "data-testid": "sales-channels"
  }, salesChannels == null ? void 0 : salesChannels.map(saleChannel => /*#__PURE__*/React.createElement(SaleChannel, {
    key: _.uniqueId('salesChannelsSideBar')
  }, saleChannel.icon, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3,
    color: "darkGray"
  }, saleChannel.label)))), otherLabels == null ? void 0 : otherLabels.map((item, index) => /*#__PURE__*/React.createElement(Text, {
    key: index,
    fontSize: 1,
    textAlign: "center",
    color: "darkGray",
    fontWeight: "medium"
  }, item))), !!(social != null && (_social$links = social.links) != null && _social$links.length) && /*#__PURE__*/React.createElement(Box, {
    m: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "small",
    py: 2,
    textAlign: "center"
  }, social == null ? void 0 : social.title), /*#__PURE__*/React.createElement(HorizontalRule, {
    style: {
      margin: '0 auto 12px',
      width: '50%'
    }
  }), /*#__PURE__*/React.createElement(IconsContainer, null, social.links.map((item, index) => /*#__PURE__*/React.createElement("a", {
    key: index,
    rel: "noreferrer",
    href: item == null ? void 0 : item.url,
    target: "_blank",
    title: item == null ? void 0 : item.label
  }, /*#__PURE__*/React.createElement(Image, {
    src: item == null ? void 0 : item.img,
    alt: item == null ? void 0 : item.label
  }))))), (account == null ? void 0 : account.name) && /*#__PURE__*/React.createElement(LogoutLink, {
    "data-testid": "logout-link",
    onClick: onLogout,
    href: account == null ? void 0 : account.signOutUrl,
    bg: "primary",
    underlineOnHover: false,
    textAlign: "center",
    underline: true,
    mt: 4,
    py: 3
  }, "N\xE3o \xE9 ", account == null ? void 0 : account.name, "? Sair"));
};

SidebarMenu.defaultProps = {
  onLogout: () => {},
  onMenuHeaderClick: () => {},
  onCollapsedClick: () => {},
  onMenuItemClick: () => ({}),
  groupedLinks: []
};
process.env.NODE_ENV !== "production" ? SidebarMenu.propTypes = {
  onMenuHeaderClick: func,
  onMenuItemClick: func,
  onCollapsedClick: func,
  data: shape({
    header: shape({
      label: string.isRequired,
      subtitles: arrayOf(string),
      ellipsis: bool,
      url: string.isRequired,
      helpers: arrayOf(shape({
        id: string.isRequired,
        label: string.isRequired,
        url: string.isRequired
      })).isRequired
    }),
    groupedLinks: arrayOf(arrayOf(shape({
      label: string,
      url: string
    }))),
    showcaseLinks: arrayOf(shape({
      name: string,
      value: string
    })),
    categoryList: shape({
      orderBy: arrayOf(string),
      collapseText: string.isRequired,
      list: arrayOf(shape({
        id: string.isRequired,
        label: string.isRequired,
        url: string
      })).isRequired
    }),
    externalLinks: shape({
      title: string.isRequired,
      list: arrayOf(shape({
        label: string.isRequired,
        url: string.isRequired,
        id: string.isRequired
      }))
    }),
    services: shape({
      title: string.isRequired,
      list: arrayOf(shape({
        label: string.isRequired,
        url: string.isRequired,
        id: string.isRequired
      }))
    }),
    moreInformation: arrayOf(shape({
      label: string.isRequired,
      url: string.isRequired,
      id: string.isRequired
    })),
    actionButtons: arrayOf(shape({
      label: string.isRequired,
      url: string.isRequired,
      id: string
    })),
    account: shape({
      url: string,
      name: string,
      signOutUrl: string
    }),
    helperText: oneOfType([string, arrayOf(string)]),
    salesChannels: arrayOf(shape({
      label: string,
      icon: object
    }))
  }).isRequired,
  onLogout: func
} : void 0;
export default SidebarMenu;